import { FC } from 'react'
import { MiFooter } from '../../components/mi/Footer'
import { MiNavbar } from '../../components/mi/Navbar'
import { ContractDetailsSection } from '../../components/mi/contracts/details'
import { StyleBody } from '../../styles/mi'

export const ContractDetails: FC = () => {
  return (
    <StyleBody>
      <MiNavbar />
      <ContractDetailsSection></ContractDetailsSection>
      <MiFooter />
    </StyleBody>
  )
}
